var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge bg-secondary me-1"},[_vm._v(" "+_vm._s(_vm.role.description)+" "),(_vm.idUser)?_c('span',{staticClass:"btn-unset",on:{"click":function($event){return _vm.unsetAdmin()}}},[_vm._v("X")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }